import { Report, ReportingEndpoint, ReportingUpType } from "../../services/reporting";
import { googleTagManager } from "../../utils/googleAnalytics";
import { DelayedReport, getDelayedKey } from "../delayedReport/delayedReport";
export const PRODUCT_FROM_AUTOCOMPLETE = "product-seen-from-autocomplete";
export const CATEGORY_FROM_AUTOCOMPLETE = "category-seen-from-autocomplete";
export const POPULAR_SEARCH_FROM_AUTOCOMPLETE = "popular-search-seen-from-autocomplete";
export function hasSvelteAutocompleteDelayedReport() {
    return getDelayedKey(PRODUCT_FROM_AUTOCOMPLETE) in localStorage || getDelayedKey(PRODUCT_FROM_AUTOCOMPLETE) in localStorage;
}
export const Autocomplete = (getBase) => ({
    reportProductClicked: (props) => {
        if (props === null || props === void 0 ? void 0 : props.gtag_product_items) {
            googleTagManager("event", 'select_item', { items: props.gtag_product_items });
            delete props.gtag_product_items;
        }
        // googleAnalyticsLegacy("push", ['_trackEvent', 'Fast Simon', "Product Suggest", props.h, props.original_search_query.length]);
        // googleAnalytics("send", "event", {
        //     eventCategory: 'Fast Simon',
        //     eventAction: 'Product Suggest',
        //     eventLabel: props.h
        // })
        // googleTagManager('event', 'Product Suggest', {
        //     'event_category': 'Fast Simon',
        //     'event_label': props.h
        // });
        return DelayedReport(Object.assign(Object.assign({ prefix: PRODUCT_FROM_AUTOCOMPLETE, endpoint: ReportingEndpoint.Autocomplete, upType: ReportingUpType.autocompleteProductSeen, site: true }, getBase()), { params: props }));
    },
    reportCategoryClicked: (props) => {
        if (props === null || props === void 0 ? void 0 : props.gtag_data) {
            googleTagManager("event", "category_click", Object.assign({}, props.gtag_data));
            delete props.gtag_data;
        }
        return Report(Object.assign(Object.assign({ endpoint: ReportingEndpoint.Autocomplete, upType: ReportingUpType.categorySearchSeen, site: true }, getBase()), { params: props }));
    },
    reportCategoryClickedDelayed: (props) => {
        if (props === null || props === void 0 ? void 0 : props.gtag_data) {
            googleTagManager("event", "category_click", Object.assign({}, props.gtag_data));
            delete props.gtag_data;
        }
        return DelayedReport(Object.assign(Object.assign({ prefix: CATEGORY_FROM_AUTOCOMPLETE, endpoint: ReportingEndpoint.Autocomplete, upType: ReportingUpType.categorySearchSeen, site: true }, getBase()), { params: props }));
    },
    reportPopularSearchClicked: (props) => {
        if (props === null || props === void 0 ? void 0 : props.gtag_data) {
            googleTagManager("event", "popular_search_click", Object.assign({}, props.gtag_data));
            delete props.gtag_data;
        }
        return Report(Object.assign(Object.assign({ endpoint: ReportingEndpoint.Autocomplete, upType: ReportingUpType.popularSearchSeen, site: true }, getBase()), { params: props }));
    },
    reportPopularSearchClickedDelayed: (props) => {
        if (props === null || props === void 0 ? void 0 : props.gtag_data) {
            googleTagManager("event", "popular_search_click", Object.assign({}, props.gtag_data));
            delete props.gtag_data;
        }
        return DelayedReport(Object.assign(Object.assign({ prefix: POPULAR_SEARCH_FROM_AUTOCOMPLETE, endpoint: ReportingEndpoint.Autocomplete, upType: ReportingUpType.popularSearchSeen, site: true }, getBase()), { params: props }));
    }
});
//# sourceMappingURL=autocomplete.js.map